module.exports = __webpack_public_path__ + "img/及格.fe46ae79.png";